import { createElement, memo, useMemo, useCallback } from '@max/max';
import View from '@hfe/max-view';
import Image from '@hfe/max-image';
import Text from '@hfe/max-text';
import { getImageUrl } from '../../../lib/utils/imageUtils';
import './index.scss';
const FlightTheme4 = (props) => {
    const leftData = useMemo(() => {
        if (props.data && props.data.length) {
            return props.data.filter((_item, index) => {
                return index % 2 === 0;
            });
        }
        else {
            return [];
        }
    }, [props.data]);
    const rightData = useMemo(() => {
        if (props.data && props.data.length) {
            return props.data.filter((_item, index) => {
                return index % 2 === 1;
            });
        }
        else {
            return [];
        }
    }, [props.data]);
    const formatDate = useCallback((date) => {
        const newDate = new Date(date);
        return newDate.getFullYear() + '年' + (newDate.getMonth() + 1) + '月' + newDate.getDate() + '日';
    }, []);
    return <View className="flight-theme-4">
      <View className="flight-container">
        {leftData.map((item, index) => {
        var _a;
        return <View className='flight-card' key={index} style={{
            marginTop: index === 0 ? '0rpx' : '18rpx'
        }}>
              <View className='flight-img' onClick={() => props.jump(item, index * 2)} style={{
            height: props.data.length > 6 && index === 0 ? '419rpx' : '176rpx'
        }}>
                <Image className='light-img-item' source={{
            uri: ((_a = props === null || props === void 0 ? void 0 : props.data) === null || _a === void 0 ? void 0 : _a.length) > 3 && index === 0 ? item.bigPicurl ? getImageUrl(item.bigPicurl, 312, 0) : getImageUrl(item.picurl, 312, 0) : getImageUrl(item.picurl, 312, 0)
        }} style={{
            width: '100%',
            height: '100%'
        }}/>
                <Text className='label-word' style={{
            backgroundColor: props.cornerLabelBgColor,
            color: props.cornerLabelColor
        }}>{item.backup ? props.cornerLabelBackup ? props.cornerLabelBackup : props.cornerLabelWord : props.cornerLabelWord}</Text>
              </View>
              <View className='flight-city' onClick={() => props.jump(item, index * 2)} style={{
            paddingTop: '20rpx',
            height: '68rpx'
        }}>
                <View className='flight-city-row'>
                  <Text className='flight-city-name'>{item.departCityName}</Text>
                  <Image className='flight-city-img' source={{
            uri: 'https://p0.meituan.net/travelcube/ed36f024c548043efcf0d6631890c3c91627.png'
        }}/>
                  <Text className='flight-city-name'>{item.arriveCityName}</Text>
                </View>
                <View className='flight-city-row' style={{
            alignItems: 'baseline'
        }}>
                  <Text className='flight-price-icon' style={{
            marginRight: '2rpx'
        }}>¥</Text>
                  <Text className='flight-price'>{item.price}</Text>
                </View>
              </View>
              <View className='flight-city' onClick={() => props.jump(item, index * 2)} style={{
            marginTop: '6rpx',
            height: '33rpx'
        }}>
                <Text className="flight-time">{formatDate(item.date)}</Text>
                <Text className="flight-discout">{item.discout > 0 ? `${item.discout / 10}折` : ''}</Text>
              </View>
            </View>;
    })}

      </View>
      <View className="flight-container">
        {rightData.map((item, index) => {
        var _a;
        return <View className='flight-card' key={index} style={{
            marginTop: index === 0 ? '0rpx' : '18rpx'
        }}>
              <View className="flight-img" onClick={() => props.jump(item, index * 2 + 1)} style={{
            height: props.data.length > 6 && index === 2 ? '419rpx' : '176rpx'
        }}>
                <Image style={{
            height: '100%',
            width: '100%'
        }} source={{
            uri: ((_a = props === null || props === void 0 ? void 0 : props.data) === null || _a === void 0 ? void 0 : _a.length) > 3 && index === 2 ? item.bigPicurl ? getImageUrl(item.bigPicurl, 312, 0) : getImageUrl(item.picurl, 312, 0) : getImageUrl(item.picurl, 312, 0)
        }}/>
                <Text className='label-word' style={{
            backgroundColor: props.cornerLabelBgColor,
            color: props.cornerLabelColor
        }}>{item.backup ? props.cornerLabelBackup ? props.cornerLabelBackup : props.cornerLabelWord : props.cornerLabelWord}</Text>
              </View>
              <View className="flight-city" onClick={() => props.jump(item, index * 2 + 1)} style={{
            paddingTop: '20rpx',
            height: '68rpx'
        }}>
                <View className='flight-city-row'>
                  <Text className='flight-city-name'>{item.departCityName}</Text>
                  <Image className='flight-city-img' source={{
            uri: 'https://p0.meituan.net/travelcube/ed36f024c548043efcf0d6631890c3c91627.png'
        }}/>
                  <Text className='flight-city-name'>{item.arriveCityName}</Text>
                </View>
                <View className="flight-city-row" onClick={() => props.jump(item, index * 2 + 1)} style={{
            alignItems: 'baseline'
        }}>
                  <Text className='flight-price-icon' style={{
            marginRight: '2rpx'
        }}>¥</Text>
                  <Text className='flight-price'>{item.price}</Text>
                </View>
              </View>
              <View className="flight-city" style={{
            marginTop: '6rpx',
            height: '33rpx'
        }}>
                <Text className="flight-time">{formatDate(item.date)}</Text>
                <Text className="flight-discout">{item.discout > 0 ? `${item.discout / 10}折` : ''}</Text>
              </View>
            </View>;
    })}
      </View>
    </View>;
};
export default memo(FlightTheme4);
